/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ScheduledOrder } from "../../../../core/models/scheduled-order.interface";
import { Site } from "../../../../core/models/site.interface";
import { ShippingRateCalculationError } from "../../../../core/models/shipping-rate-calculation-error.interface";

/**
 * Shipping Rate Calculation Errors Dialog Component
 * Displays errors that occurred during shipping rate calculations
 * Modern Angular implementation of old QMC ShippingRateCalculationErrorsPopupComponent
 * Used with PrimeNG DialogService
 */
@Component({
  selector: "app-shipping-rate-calculation-errors-dialog",
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: "./shipping-rate-calculation-errors-dialog.component.html",
  styleUrls: ["./shipping-rate-calculation-errors-dialog.component.scss"],
})
export class ShippingRateCalculationErrorsDialogComponent implements OnInit {
  scheduledOrder!: ScheduledOrder;
  site?: Site;

  /**
   * List of shipping rate calculation errors
   */
  shippingRateCalculationErrors: ShippingRateCalculationError[] = [];

  /**
   * Tracks which error details are expanded
   */
  showingDetails: Record<number, boolean> = {};

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    // Get data from DialogService config
    this.scheduledOrder = this.config.data.scheduledOrder;
    this.site = this.config.data.site;

    this.loadShippingRateCalculationErrors();
  }

  /**
   * Load shipping rate calculation errors from scheduled order metadata
   */
  private loadShippingRateCalculationErrors(): void {
    if (
      this.scheduledOrder.Metadata &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      (this.scheduledOrder.Metadata as any).ShippingRateCalculationErrors
    ) {
      this.shippingRateCalculationErrors =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        (this.scheduledOrder.Metadata as any)
          .ShippingRateCalculationErrors as ShippingRateCalculationError[];
    }
  }

  /**
   * Toggle details visibility for a specific error
   */
  toggleDetails(index: number): void {
    this.showingDetails[index] = !this.showingDetails[index];
  }

  /**
   * Check if details are showing for a specific error
   */
  isShowingDetails(index: number): boolean {
    return this.showingDetails[index] || false;
  }

  /**
   * Close the dialog
   */
  close(): void {
    this.ref.close();
  }
}
